function handleExpiredSession() {
  localStorage.removeItem("auth");
  // Emit a custom event so AuthContext can react without a circular import
  window.dispatchEvent(new CustomEvent("auth:expired"));
  window.location.href = "/login";
}

export async function apiFetch(url, options = {}) {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const token = auth?.token;

  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
  };

  try {
    const res = await fetch(url, { ...options, headers });
    if (res.status === 401) {
      handleExpiredSession();
      // Return a non-ok response so callers don't try to parse a redirect body
      return { ok: false, status: 401, json: async () => ({}), text: async () => "" };
    }
    return res;
  } catch (err) {
    return {
      ok: false,
      status: 0,
      statusText: err?.message || "Failed to fetch",
      json: async () => ({}),
      text: async () => "",
    };
  }
}
